import { ParamType } from "../../../../poly/ParamType";
import { RampParam } from "../../../../params/Ramp";
export var GlConnectionPointType = /* @__PURE__ */ ((GlConnectionPointType2) => {
  GlConnectionPointType2["BOOL"] = "bool";
  GlConnectionPointType2["INT"] = "int";
  GlConnectionPointType2["FLOAT"] = "float";
  GlConnectionPointType2["VEC2"] = "vec2";
  GlConnectionPointType2["VEC3"] = "vec3";
  GlConnectionPointType2["VEC4"] = "vec4";
  GlConnectionPointType2["SAMPLER_2D"] = "sampler2D";
  GlConnectionPointType2["SSS_MODEL"] = "SSSModel";
  return GlConnectionPointType2;
})(GlConnectionPointType || {});
export const GL_CONNECTION_POINT_TYPES = [
  "bool" /* BOOL */,
  "int" /* INT */,
  "float" /* FLOAT */,
  "vec2" /* VEC2 */,
  "vec3" /* VEC3 */,
  "vec4" /* VEC4 */
];
export const GlConnectionPointTypeToParamTypeMap = {
  ["bool" /* BOOL */]: ParamType.BOOLEAN,
  ["int" /* INT */]: ParamType.INTEGER,
  ["float" /* FLOAT */]: ParamType.FLOAT,
  ["vec2" /* VEC2 */]: ParamType.VECTOR2,
  ["vec3" /* VEC3 */]: ParamType.VECTOR3,
  ["vec4" /* VEC4 */]: ParamType.VECTOR4,
  ["sampler2D" /* SAMPLER_2D */]: ParamType.RAMP,
  ["SSSModel" /* SSS_MODEL */]: ParamType.STRING
};
export const GLParamTypeToConnectionPointTypeMap = {
  [ParamType.BOOLEAN]: "bool" /* BOOL */,
  [ParamType.COLOR]: "vec3" /* VEC3 */,
  [ParamType.INTEGER]: "int" /* INT */,
  [ParamType.FLOAT]: "float" /* FLOAT */,
  [ParamType.FOLDER]: void 0,
  [ParamType.VECTOR2]: "vec2" /* VEC2 */,
  [ParamType.VECTOR3]: "vec3" /* VEC3 */,
  [ParamType.VECTOR4]: "vec4" /* VEC4 */,
  [ParamType.BUTTON]: void 0,
  [ParamType.PARAM_PATH]: void 0,
  [ParamType.NODE_PATH]: void 0,
  [ParamType.RAMP]: void 0,
  [ParamType.STRING]: void 0
};
export const GlConnectionPointInitValueMap = {
  ["bool" /* BOOL */]: false,
  ["int" /* INT */]: 0,
  ["float" /* FLOAT */]: 0,
  ["vec2" /* VEC2 */]: [0, 0],
  ["vec3" /* VEC3 */]: [0, 0, 0],
  ["vec4" /* VEC4 */]: [0, 0, 0, 0],
  ["sampler2D" /* SAMPLER_2D */]: RampParam.DEFAULT_VALUE_JSON,
  ["SSSModel" /* SSS_MODEL */]: "SSSModel()"
};
export const GlConnectionPointComponentsCountMap = {
  ["bool" /* BOOL */]: 1,
  ["int" /* INT */]: 1,
  ["float" /* FLOAT */]: 1,
  ["vec2" /* VEC2 */]: 2,
  ["vec3" /* VEC3 */]: 3,
  ["vec4" /* VEC4 */]: 4,
  ["sampler2D" /* SAMPLER_2D */]: 1,
  ["SSSModel" /* SSS_MODEL */]: 1
};
import { BaseConnectionPoint } from "./_Base";
export class GlConnectionPoint extends BaseConnectionPoint {
  constructor(_name, _type, _init_value) {
    super(_name, _type);
    this._name = _name;
    this._type = _type;
    this._init_value = _init_value;
    this._init_value = this._init_value || GlConnectionPointInitValueMap[this._type];
  }
  type() {
    return this._type;
  }
  are_types_matched(src_type, dest_type) {
    return src_type == dest_type;
  }
  get param_type() {
    return GlConnectionPointTypeToParamTypeMap[this._type];
  }
  get init_value() {
    return this._init_value;
  }
  toJSON() {
    return this._json = this._json || this._create_json();
  }
  _create_json() {
    return {
      name: this._name,
      type: this._type
    };
  }
}
